import {
    IAnimateTarget,
    IAnimationData,
    IAnimationPropertyData,
    IPropData
} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/animation/AnimationTypes';
import {AnimateRelatedProperty} from '@mintdata/mint-kit/api/animation/AnimationProps';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {color} from 'style-value-types/dist/style-value-types.js';
import {Styler} from 'stylefire';

const relatedPropsUpdater = (animationData:IAnimationData, propData:IPropData, value:any) =>
{
    if( propData.prop )
    {
        const visibilityPropPath:PropPath = PropPath.fromFieldPath(
            animationData.getPropPath(AnimateRelatedProperty.BorderVisibility)
        );
        const visibility:ABoolean = propData.prop.getPropValue(visibilityPropPath);

        if( !visibility || !visibility.value )
            propData.prop.setPropValue(visibilityPropPath, ABoolean.true());
    }
};

export const borderColorData:IAnimationPropertyData = {
    defaultFromValue: '#000000',
    setter: (animateTarget:IAnimateTarget,
             animationData:IAnimationData,
             styler:Styler,
             property:string,
             cssProperty:string,
             value:any) =>
    {
        const colorString:string = styler.get('borderColor', true);
        const parsedColor = color.parse(colorString);
        const parsedNewColor = color.parse(value);

        parsedNewColor.alpha = parsedColor.alpha;

        styler.set('borderColor', color.transform(parsedNewColor));
    },
    relatedPropsUpdater
};

export const borderOpacityData:IAnimationPropertyData = {
    cssProperty: 'borderColor',
    setter: (animateTarget:IAnimateTarget,
             animationData:IAnimationData,
             styler:Styler,
             property:string,
             cssProperty:string,
             value:any) =>
    {
        const colorString:string = styler.get('borderColor');
        const parsedColor = color.parse(colorString);

        parsedColor.alpha = value;

        styler.set('borderColor', color.transform(parsedColor));
    },
    relatedPropsUpdater
};
